/**
 * @module geo/actions/creators
 *
 */
import {promiseActionCreator} from '../../helpers/observable.to.promise';
import {GO_TO_EXTENT, GO_TO_INIT_EXTENT, PAN_TO, ZOOM_IN, ZOOM_OUT, ZOOM_TO_SCALE} from '../../payload/facade';
import {GO_TO_POINT} from '../../payload/facade/GO_TO_POINT';
import {ExtentDone} from '../../payload/response';
import {actionCreator} from '../helpers/actions.creator.builder';
import {ActionCreator} from '../helpers/fsa';
import {TypeKeyActions} from '../types.key.action';


/**
 *  @preferred
 */
// move functions
/**
 *  return an   action to zoom in on a map
 * @type {ActionCreator<ZOOM_IN>}
 * @since v 2.0.1
 */
export const zoomInCreator =
    actionCreator<ZOOM_IN>(TypeKeyActions.ZOOM_IN) as ActionCreator<ZOOM_IN>;
/**
 * action type to zoomInCreator
 * @type {AsyncActionCreators<ZOOM_IN, ExtentDone, Error>}
 * @since v 2.0.1
 */
export const zoomInAsyncCreator =
    actionCreator.async<ZOOM_IN, ExtentDone, Error>(TypeKeyActions.ZOOM_IN);
/**
 * return an  async  action to zoom in on a map
 * @since v 2.0.1
 * @private
 * @hidden
 */
export const zoomInCreatorP = promiseActionCreator(
    zoomInCreator,
    [zoomInAsyncCreator.done.type, zoomInAsyncCreator.failed.type]);
/**
 * return an action to zoom out on a map
 * @type {ActionCreator<ZOOM_OUT>}
 * @since v 2.0.1
 */
export const zoomOutCreator =
    actionCreator<ZOOM_IN>(TypeKeyActions.ZOOM_OUT) as ActionCreator<ZOOM_OUT>;
/**
 * action type to zoomOutCreator
 * @type {AsyncActionCreators<ZOOM_OUT, ExtentDone, Error>}
 * @since v 2.0.1
 */
export const zoomOutAsyncCreator =
    actionCreator.async<ZOOM_OUT, ExtentDone, any>(TypeKeyActions.ZOOM_OUT);
/**
 *  return an  async action to zoom out on a map
 * @type {ActionCreator<ZOOM_IN>}
 * @since v 2.0.1
 * @private
 * @hidden
 */
export const zoomOutCreatorP = promiseActionCreator(
    zoomOutCreator,
    [zoomOutAsyncCreator.done.type, zoomOutAsyncCreator.failed.type]);
/**
 * return an action to pan on a map
 * @type {ActionCreator<PAN_TO>}
 * @since v 2.0.1
 */
export const panToCreator =
    actionCreator<PAN_TO>(TypeKeyActions.PAN_TO) as ActionCreator<PAN_TO>;
/**
 * action type of panToCreator
 * @type {AsyncActionCreators<PAN_TO, ExtentDone,Error>}
 * @since v 2.0.1
 */
export const panToAsyncCreator =
    actionCreator.async<PAN_TO, ExtentDone, Error>(TypeKeyActions.PAN_TO);
/**
 * return an async action to pan on a map
 * @since v 2.0.1
 * @private
 * @hidden
 */
export const panToCreatorP = promiseActionCreator(
    panToCreator, [panToAsyncCreator.done.type, panToAsyncCreator.failed.type]);
/**
 * return an action permitting to return on initial extent
 * @type {ActionCreator<GO_TO_INIT_EXTENT>}
 * @since v 2.0.1
 */
export const gotoInitExtentCreator =
    actionCreator<GO_TO_INIT_EXTENT>(TypeKeyActions.GO_TO_INIT_EXTENT) as
    ActionCreator<GO_TO_INIT_EXTENT>;
/**
 * action type of gotoInitExtentCreator
 * @type {AsyncActionCreators<GO_TO_INIT_EXTENT, ExtentDone, any>}
 * @since v 2.0.1
 */
export const gotoInitExtentAsyncCreator =
    actionCreator.async<GO_TO_INIT_EXTENT, ExtentDone, Error>(
        TypeKeyActions.GO_TO_INIT_EXTENT);
/**
 * return an async action permitting to return on initial extent
 * @since v 2.0.1
 * @private
 * @hidden
 */
export const gotoInitExtentCreatorP =
    promiseActionCreator(gotoInitExtentCreator, [
      gotoInitExtentAsyncCreator.done.type,
      gotoInitExtentAsyncCreator.failed.type
    ]);
/**
 * return an action to go to a specific extent
 * @type {ActionCreator<GO_TO_EXTENT>}
 * @since v 2.0.1
 */
export const gotoExtentCreator =
    actionCreator<GO_TO_EXTENT>(TypeKeyActions.GO_TO_EXTENT) as
    ActionCreator<GO_TO_EXTENT>;
/**
 * action type of gotoExtentAsyncCreator
 * @type {AsyncActionCreators<GO_TO_EXTENT, ExtentDone, Error>}
 * @since v 2.0.1
 */
export const gotoExtentAsyncCreator =
    actionCreator.async<GO_TO_EXTENT, ExtentDone, Error>(
        TypeKeyActions.GO_TO_EXTENT);
/**
 * return an async action to go to a specific extent
 * @type {ActionCreator<GO_TO_EXTENT>}
 * @since v 2.0.1
 * @private
 * @hidden
 */
export const gotoExtentCreatorP = promiseActionCreator(
    gotoExtentCreator,
    [gotoExtentAsyncCreator.done.type, gotoExtentAsyncCreator.failed.type]);
/**
 * an function creation an action to go to a specific point on a map
 * @type {ActionCreator<GO_TO_POINT>}
 * @since v 2.0.1
 */
export const gotoPointCreator =
    actionCreator<GO_TO_POINT>(TypeKeyActions.GO_TO_POINT) as
    ActionCreator<GO_TO_POINT>;
/**
 * action type of gotoPointCreator
 * @type {AsyncActionCreators<GO_TO_POINT, ExtentDone, Error>}
 * @since v 2.0.1
 */
export const gotoPointAsyncCreator =
    actionCreator.async<GO_TO_POINT, ExtentDone, Error>(
        TypeKeyActions.GO_TO_POINT);
/**
 * an promise to a function creating an action to go to a specific point on a
 * map
 * @type {ActionCreator<GO_TO_POINT>}
 * @since v 2.0.1
 * @private
 * @hidden
 */
export const gotoPointCreatorP = promiseActionCreator(
    gotoPointCreator,
    [gotoPointAsyncCreator.done.type, gotoPointAsyncCreator.failed.type]);
/**
 * return an action builder to zoom to a specific scale
 * @type {ActionCreator<ZOOM_TO_SCALE>}
 * @since v 2.0.1
 */
export const zoomToScaleCreator =
    actionCreator<ZOOM_TO_SCALE>(TypeKeyActions.ZOOM_TO_SCALE) as
    ActionCreator<ZOOM_TO_SCALE>;
/**
 * action type of zoomToScaleCreator
 * @type {AsyncActionCreators<ZOOM_TO_SCALE, ExtentDone, any>}
 * @since v 2.0.1
 */
export const zoomToScaleAsyncCreator =
    actionCreator.async<ZOOM_TO_SCALE, ExtentDone, Error>(
        TypeKeyActions.ZOOM_TO_SCALE);
/**
 * return an action builder with a promise to zoom to a specific scale
 * @type {ActionCreator<ZOOM_TO_SCALE>}
 * @since v 2.0.1
 * @private
 * @hidden
 */
export const zoomToScaleCreatorP = promiseActionCreator(
    zoomToScaleCreator,
    [zoomToScaleAsyncCreator.done.type, zoomToScaleAsyncCreator.failed.type]);
